import React, { memo, ReactElement, ReactNode } from "react";
import classNames from "classnames";
import { withStyles } from "@swiggy-private/core-ui";

import styles from "./Shimmer.scss";

const Header = memo(function Header(props: { width?: number }) {
    const width = props.width || 30;
    return <div className={styles.blockHeader} style={{ width: width + "%" }} />;
});

const SavingsBanner = memo(function SavingsBanner() {
    return <div className={styles.blockSavingsBanner} />;
});

const Line = memo(function Line(props: { fat?: boolean; width?: number; height?: number }) {
    const lineHeight = props.height ?? (props.fat ? 16 : 12);

    return (
        <div
            className={classNames({
                [styles.line]: !props.fat,
                [styles.fatLine]: props.fat,
            })}
            style={{ width: (props.width || 100) + "%", height: lineHeight + "px" }}
        />
    );
});

const Circle = memo(function Circle(props: { size?: number }) {
    const size = props.size || 20;
    return <div className={styles.circle} style={{ width: size + "px", height: size + "px" }} />;
});

const Row = memo(function Row(props: { children?: ReactNode }) {
    return <div className={styles.row}>{props.children}</div>;
});

const Col = memo(function Col(props: { children?: ReactNode }) {
    return <div className={styles.col}>{props.children}</div>;
});

const Shimmerv4 = (): ReactElement => {
    return (
        <div className={styles.container}>
            <div className={styles.block}>
                <SavingsBanner />
            </div>

            <div className={styles.block}>
                <Header />
                <div className={styles.blockContent}>
                    <Row>
                        <Line fat width={60} />
                        <Line fat width={20} />
                    </Row>
                    <Row>
                        <Line fat width={40} />
                        <Line fat width={20} />
                    </Row>

                    <div className={styles.divider} />

                    <Row>
                        <Line fat width={80} />
                        <Circle />
                    </Row>
                </div>
            </div>

            <div className={styles.block}>
                <Header width={45} />
                <div className={styles.blockContent}>
                    <Col>
                        <Line fat width={40} />
                        <Line width={60} />
                    </Col>
                </div>
                <div className={styles.blockContent}>
                    <Col>
                        <Line fat width={40} />
                        <Line width={75} />
                        <Line width={75} />
                    </Col>
                </div>
            </div>

            <div className={styles.block}>
                <Header width={55} />
                <div className={styles.blockContent}>
                    <Col>
                        <Line fat width={40} />
                        <Line width={75} />
                        <Line width={75} />
                    </Col>
                </div>
            </div>

            <div className={classNames(styles.block, styles.blockFixedBottom)}>
                <div className={classNames(styles.blockContent, styles.blockContentFooter)}>
                    <Row>
                        <Col>
                            <Line fat width={40} />
                            <Line width={65} />
                        </Col>

                        <Col>
                            <Line fat width={100} height={44} />
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
};

export default withStyles(Shimmerv4, styles);
